import React, { useReducer } from 'react';
import { LayoutContext } from './layoutContext';
import { defaultState } from '@/hooks/layouts/defaultState';
import { reducer } from '@/hooks/layouts/reducer';

export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducer, defaultState);
    return <LayoutContext.Provider value={{ state, dispatch }}>{children}</LayoutContext.Provider>;
};
